import React, { useState, useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import html2canvas from "html2canvas";

const EmpInputFieldEsign = ({ inputObj, onUpdate }) => {
  const { key, value } = inputObj;

  const [signature, setSignature] = useState({ trimmedDataURL: value ?? "" });
  const [size, setSize] = useState({ height: 0, width: 0 });
  const [signatureType, setSignatureType] = useState("draw");

  const sigCanvasRef = useRef(null);
  const previewRef = useRef(null);

  const [text, setText] = useState("");
  const [font, setFont] = useState("Dancing Script");

  const fonts = [
    "Dancing Script",
    "Great Vibes",
    "Pacifico",
    "Satisfy",
    "Allura",
  ];

  useEffect(() => {
    const div = document.getElementById("signature_div");

    if (div) {
      setSize({
        height: div.offsetHeight,
        width: div.offsetWidth,
      });
    }
  }, [signatureType]);

  // DRAW SIGNATURE
  const signatureFunc = () => {
    if (!sigCanvasRef.current) return;

    const canvas = sigCanvasRef.current.getCanvas();
    const dataUrl = canvas.toDataURL("image/png");

    // setSignature({ trimmedDataURL: dataUrl });
    onUpdate(key, dataUrl);
  };

  // TYPE SIGNATURE
  const typeSignatureFunc = async () => {
    if (!previewRef.current) return;

    const canvas = await html2canvas(previewRef.current);

    const trimmedDataURL = canvas.toDataURL("image/png");

    // setSignature({ trimmedDataURL });
    onUpdate(key, trimmedDataURL);
  };

  return (
    <div className="w-full">
      {/* SIGNATURE TYPE BUTTONS */}

      {/* <div className="flex gap-3 mb-3">
        <button
          onClick={() => setSignatureType("draw")}
          className={`px-4 py-1 rounded ${
            signatureType === "draw"
              ? "bg-yellow-500 text-white"
              : "bg-gray-200"
          }`}
        >
          Draw
        </button>

        <button
          onClick={() => setSignatureType("type")}
          className={`px-4 py-1 rounded ${
            signatureType === "type"
              ? "bg-yellow-500 text-white"
              : "bg-gray-200"
          }`}
        >
          Type
        </button>
      </div> */}
      <label className="block mb-1 text-gray-200">E-Sign</label>
      {/* DRAW SIGNATURE */}

      {signatureType === "draw" && (
        <>
          <div
            id="signature_div"
            className="w-full h-40 border bg-yellow-100 rounded"
          >
            {size.height > 0 && (
              <SignatureCanvas
                ref={sigCanvasRef}
                penColor="black"
                canvasProps={{
                  height: size.height,
                  width: size.width,
                }}
              />
            )}
          </div>

          <div className="flex gap-3 mt-2">
            <button
              onClick={() => sigCanvasRef.current.clear()}
              className="px-3 py-1 bg-gray-300 rounded"
            >
              Clear
            </button>

            <button
              onClick={signatureFunc}
              className="px-3 py-1 bg-[#caa96a] rounded"
            >
              Apply Signature
            </button>
          </div>
        </>
      )}

      {/* TYPE SIGNATURE */}

      {/* {signatureType === "type" && (
        <>
          <div className="h-40 flex items-center justify-center border bg-yellow-100 rounded">
            <span
              ref={previewRef}
              style={{
                fontFamily: font,
                fontSize: "34px",
              }}
            >
              {text}
            </span>
          </div>

          <div className="flex gap-2 mt-3">
            <input
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Your Signature"
              className="w-full border px-3 py-2 rounded"
            />

            <select
              value={font}
              onChange={(e) => setFont(e.target.value)}
              className="border px-3 py-2 rounded"
            >
              {fonts.map((f) => (
                <option key={f}>{f}</option>
              ))}
            </select>
          </div>

          <button
            onClick={typeSignatureFunc}
            className="mt-2 px-3 py-1 bg-yellow-500 rounded"
          >
            Apply Signature
          </button>
        </>
      )} */}
    </div>
  );
};
export default EmpInputFieldEsign;